import rootMessages from './en_US.json'
import generalMessages from './general/en_US.json'

export const sharedMessages = {
    ...rootMessages,
    ...generalMessages,
}
